import format from "date-fns/format";
import es from "date-fns/locale/es";
import de from "date-fns/locale/de";
import fr from "date-fns/locale/fr";
import { distanceInWordsToNow } from "date-fns";

const dateLocaleMap = { es, fr, de };

// Returns in format of -19:00 or +11:00
export const getTimezoneOffset = (date = new Date()) => {
  return format(date, "Z");
};

export const formatDateDistance = (date, locale) => {
  return distanceInWordsToNow(new Date(date), {
    locale: dateLocaleMap[locale],
    addSuffix: true,
  });
};
